import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveBounce24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoveBounce24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M16.385 2.917a5.4 5.4 0 0 1 5.122 5.393l-.007.278a5.4 5.4 0 0 1-5.393 5.122l-.278-.007a5.4 5.4 0 0 1-.8-.102l-2.833 5.236h7.183a.9.9 0 0 1 0 1.801H4.62a.9.9 0 0 1 0-1.8h3.407l-3.176-4.754a.901.901 0 0 1 1.498-1.001l3.819 5.716 3.169-5.854a5.4 5.4 0 0 1-2.623-4.357l-.007-.278a5.4 5.4 0 0 1 5.4-5.4zm-.278 1.793a3.601 3.601 0 0 0 0 7.2 3.6 3.6 0 0 0 0-7.2M2.592 8.943a.9.9 0 0 1 1.249.248l.567.85a.901.901 0 0 1-1.497 1l-.568-.849a.9.9 0 0 1 .249-1.249"
            />
        </svg>
    );
}
export default memo(IconMoveBounce24);
